/** Слова состояния связи модуля ресурса: единственное место, где они живут (RP-UI-LINK, `krp/connection-text`). */
export const MODULE_ANSWERING = 'Отвечает'
export const MODULE_NOT_ANSWERING = 'Не отвечает'
export const MODULE_NEVER_CHECKED = 'Связь ещё не проверялась'
